import smoothscroll from 'smoothscroll-polyfill';
import { $ } from '../util/DOM';

const initBackTopButton = () => {
  const backTopButton = document.querySelector('.back-to-top');
  window.addEventListener('scroll', () => {
    $.toggle(backTopButton, window.scrollY > 0);
  });

  backTopButton.addEventListener('click', () => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
      left: 0,
    });
    window.location.hash = '';
  });
};

const initScrollFX = () => {
  smoothscroll.polyfill();
  initBackTopButton();
};

export default initScrollFX;
